import React from 'react';

import { QUESTION_READ_TEXT } from '~/constants/read_const';

import { ReactComponent as IconInactive } from '~/assets/icons/inactive-test.svg';
import { ReactComponent as IconActive } from '~/assets/icons/active-test.svg';
import { ReactComponent as ConnectingLine } from '~/assets/icons/connecting-line.svg';

import styles from './assets/styles/styles.module.scss';

class TimerComponent extends React.Component {
  render() {
    const {
      timer: {
        hours,
        minutes,
        seconds
      },
      active
    } = this.props;

    return (
      <div className={styles['timer-block']}>
        <div className={styles.container}>
          <p className={styles.time}>
            {`${hours < 10 ? `0${hours}` : hours} :
            ${minutes < 10 ? `0${minutes}` : minutes} :
            ${seconds < 10 ? `0${seconds}` : seconds}`}
          </p>
          <nav className={styles.navigation}>
            <div className={styles['nav-block']}>
              {QUESTION_READ_TEXT.map((text, index) => (
                <span className={styles['nav-element']} key={index}>
                  <span className={styles.icon}>
                    {index <= active ? (
                      <IconActive className={`${styles['nav-icon']} ${styles['active-timer-icon']}`} />
                    ) : (
                      <IconInactive className={`${styles['nav-icon']} ${styles['inactive-timer-icon']}`}/>
                    )}
                    <span className={styles[`nav-text${index <= active ? '_active' : ''}`]}>
                      {text}
                    </span>
                  </span>
                  {index !== QUESTION_READ_TEXT.length - 1 && (
                    <ConnectingLine className={styles[`nav-line${index <= active ? '_active' : ''}`]} />
                  )}
                </span>
              ))}
            </div>
          </nav>
        </div>
      </div>
    );
  }
}

export default TimerComponent;
